import React, {useEffect, useState} from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import lang from "../../img/lang.png"
import Logo from "../../img/LOGO.png"
import useTokenStore from "../Store/Store";

const Styled ={
    Wrap:styled.div`
        width:100%;
        height:94px;
        display:flex;
        justify-content:space-evenly;
        align-items:center;
        flex-direction:column;
        background-color:#ffffff;
        z-index:3;
    `,
        LogoWrap:styled.div`
            width:90%;
            height:44px;
            display:flex;
            justify-content:flex-start;
            align-items:center;
            flex-direction:row;
        `,
            Logo:styled.img`
                width:94px;
                height:20px;
            `,
        CallWrap:styled.div`
            width:90%;
            height:50px;
            display:flex;
            justify-content:space-between;
            align-items:center;
            flex-direction:column;
        `,
            Bar:styled.div`
                width:100%;
                height:1px;
                background-color:#E9E9E9;
            `,
            // 회색 바
            CallRowWrap:styled.div`
                width:100%;
                height:36px;
                display:flex;
                justify-content:space-between;
                align-items:center;
                flex-direction:row;
            `,
            // 버튼 모음.zip
                CallBox:styled.div`
                    width:23.1%;
                    height:36px;
                    border-radius:6px;
                    background-color:#2277F6;
                    display:flex;
                    justify-content:center;
                    align-items:center;
                    flex-direction:column;
                    &:hover{
                        cursor:pointer;
                    }
                `,
                // 버튼
                    CallBoxText:styled.p`
                        font-size:14px;
                        color:#ffffff;
                        margin:0px;
                        font-family:'PreFont';
                        font-weight:400;
                    `,
                    CallImg:styled.img`
                        width:45px;
                        height:20px;
                    `,
                    // 버튼 텍스트
}
const Call=(props)=>{
    const navigate = useNavigate();
    const {setCallOpen, setLangSetting, NowLang} = props
    const {
        Pocket,
        setPocket,
        PocketNum
    } = useTokenStore()
    const [Cart, setCart] = useState({
        "KR":"장바구니",
        "EN":"Cart",
        "CN":"购物车",
        "JP":"カート",
        "FR":"panier",
        "SP":"carrito",
        "GR":"Warenkorb",
        "RU":"корзина"
    })
    const [OrderList, setOrderList] = useState({
        "KR":"주문내역",
        "EN":"Orders",
        "CN":"订单详情",
        "JP":"注文履歴",
        "FR":"commande",
        "SP":"pedidos",
        "GR":"Bestellung",
        "RU":"заказ"
    })
    const [Call, setCall] = useState({
        "KR":"직원호출",
        "EN":"Help",
        "CN":"呼叫员工",
        "JP":"呼び出し",
        "FR":"appel",
        "SP":"llamada",
        "GR":"Ruf",
        "RU":"вызов"
    })
    const [uuid, setuuid]=useState(undefined)
    useEffect(()=>{
        const saved_uuid_data = JSON.parse(localStorage.getItem("uuid_data"));
        console.log(saved_uuid_data)
        setuuid(saved_uuid_data)
    },[])

    return(
        <Styled.Wrap>
            <Styled.LogoWrap>
                <Styled.Logo src={Logo}/>
            </Styled.LogoWrap>
            <Styled.CallWrap>
                <Styled.CallRowWrap>
                    <Styled.CallBox onClick={()=>{navigate(`/cart/${uuid}`)}}>
                        <Styled.CallBoxText>{Cart[NowLang]}: {Pocket.length}</Styled.CallBoxText>
                    </Styled.CallBox>
                    <Styled.CallBox onClick={()=>{navigate("/OrderList")}}>
                        <Styled.CallBoxText>{OrderList[NowLang]}</Styled.CallBoxText>
                    </Styled.CallBox>
                    <Styled.CallBox onClick={()=>{setCallOpen(true)}}>
                        <Styled.CallBoxText>{Call[NowLang]}</Styled.CallBoxText>
                    </Styled.CallBox>
                    <Styled.CallBox onClick={()=>{setLangSetting(true)}}>
                        <Styled.CallImg src={lang}/>
                    </Styled.CallBox>
                </Styled.CallRowWrap>
            </Styled.CallWrap>
        </Styled.Wrap>
    )
}
export default Call